<template>
  <div>
    <el-row><i class="el-icon-s-grid"></i>子码<el-button type="primary" icon="el-icon-back" size="mini" @click="goback()">返回</el-button></el-row>
    <el-divider></el-divider>
    <el-row type="flex" justify="space-between">
      <el-col :span="4">
      <el-upload
        ref = "uperweima"
        :action="'https://api.weikelink.com/open/api/uploadQrImg?access_token=' + access_token"
        accept="image/png,image/jpeg"
        name="files"
        :headers="upheaders"
        :multiple="true"
        :show-file-list="false"
        :file-list="fileList"
        :on-success="upsuccess"
        :on-error="uperr">
        <el-button type="primary" icon="el-icon-plus">添加图片</el-button>
      </el-upload>
      </el-col>
      <el-col>
        <el-button type="success" icon="el-icon-finished" @click="save()">保存</el-button>
      </el-col>
    </el-row>
    <el-table highlight-current-row
      :data="tableData"
      style="width: 100%"
      @cell-click="cellclick">
      <el-table-column
        type="selection"
        width="55">
      </el-table-column>
      <el-table-column
        prop="img_weight"
        label="优先级"
        width="80">
        <template slot-scope="scope">
          <div>{{scope.row.img_weight}}</div> <el-button type="text" size="small" icon="el-icon-edit" @click="editweight(scope.$index,scope.row.img_weight)"></el-button>
        </template>
      </el-table-column>
      <el-table-column
        prop="img_data"
        label="内容"
        align="center"
        width="300">
          <template slot-scope="scope">
            <el-row type="flex" justify="center">
              <el-col :span="10">
                  <el-image
                    style="width: 100px; height: 100px"
                    :src="zimaurl(scope.row.img_data)"
                    fit="fill">
                  </el-image>
              </el-col>
              <el-col :span="14">
                <el-upload
                  :action="'https://api.weikelink.com/open/api/uploadQrImg?access_token=' + access_token"
                  accept="image/png,image/jpeg"
                  name="files"
                  :headers="upheaders"
                  :multiple="false"
                  :file-list="fileList"
                  :show-file-list="false"
                  :on-success="upsuccess1">
                  <el-button>更换</el-button>
                </el-upload>
              </el-col>
            </el-row>
          </template>
      </el-table-column>
      <el-table-column
        prop="img_name"
        align="center"
        label="图片名称">
        <template slot-scope="scope">
          <div>
              {{scope.row.img_name}}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        label="访问上限">
        <template slot-scope="scope">
          <div>总上限：{{scope.row.img_up_limit?scope.row.img_up_limit:'无限'}}</div>
          <div>每日上限：{{scope.row.img_day_up_limit?scope.row.img_day_up_limit:'无限'}}</div>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        label="访问数">
        <template slot-scope="scope">
          <div>总访问数：{{scope.row.img_uv_num?scope.row.img_uv_num:0}}</div>
           <div>今日访问数：{{scope.row.img_day_uv_num?scope.row.img_day_uv_num:0}}</div>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        label="长按数">
        <template slot-scope="scope">
          <div>总长按数：{{scope.row.img_long_num?scope.row.img_long_num:0}}</div>
          <div>今日长按数：{{scope.row.img_day_long_num?scope.row.img_day_long_num:0}}</div>
        </template>
      </el-table-column>
      <el-table-column
        prop="img_time"
        align="center"
        label="过期时间">
        <template slot-scope="scope">
          <div>
              {{scope.row.img_time?scope.row.img_time:'永不过期'}}
          </div>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" min-width="100">
        <template slot-scope="scope">
          <el-row :gutter="20">
            <el-col :span="24"><el-button size="mini" type="primary" icon="el-icon-delete" @click="del(scope.$index)">删除</el-button></el-col></el-row>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        editor: null,
        html: null,
        editorText: '',
        title: '添加',
        loading: false, //是显示加载
        tableData: [],
        dqindex:null,
        fileList: [],
        multipleSelection: [],
        radio1:'',
        access_token:'', //weikelink的token
        id: '',
        upheaders: {
              'User-Agent': 'Apifox/1.0.0 (https://apifox.com)'
        }
      }
    },
    methods: {
      cellclick(row, column, cell, event){
          const index = this.tableData.indexOf(row); // 根据 row 对象查询到其所在位置的索引值
          if(!this.dqindex){
            this.dqindex = index
          }
      },
      save(){
        let _that = this
        let data = JSON.stringify({
           "id": _that.id,
           "newQrImgData": _that.tableData
        });

        let config = {
           method: 'post',
           url: _that.$linkUrl + '/open/api/modifyQrService?access_token=' + _that.access_token,
           headers: {
              'User-Agent': 'Apifox/1.0.0 (https://apifox.com)',
              'Content-Type': 'application/json'
           },
           data : data
        };

        _that.$axios(config)
        .then(function (response) {
//           console.log(response.data);
           if(response.data.code == 200 && response.data.message == "SUCCESS"){
             _that.$message.success(response.data.data)
           }
        })
        .catch(function (error) {
//           console.log(error);
        });
      },
      zimaurl(url){
        return 'https://res.weikelink.com/upload_img/' + url
      },
      goback() {
        this.$router.go(-1);
      },
      //子码上传成功
      upsuccess1(response, file, fileList){
//        console.log(response)
        if(response.code == 200){
          this.tableData[this.dqindex].img_data = response.data
          this.tableData[this.dqindex].img_name = file.name
          this.$message.success("上传成功！")
          this.fileList = []
        }
      },
      uperr(err, file, fileList){

      },
      //子码上传成功
      upsuccess(response, file, fileList){
        console.log(file);
        if(response.code == 200){
          let newObj = {
              "img_weight": 0,
              "img_data": response.data,
              "img_name": file.name,
              "img_time": null,
              "img_up_limit": null,
              "img_day_up_limit": null,
              "img_uv_num": null,
              "img_day_uv_num": null,
              "img_long_num": null,
              "img_day_long_num": null,
              "enabled": true,
              "wechat_number": null,
              "file_id": null,
              "status": 0,
              "reason": null
          }
          this.tableData.push(newObj)
//          this.$message.success("上传成功！")
//          this.fileList = []
        }
      },
      gettoken(){
        let _that = this
        let config = {
           method: 'post',
           url: _that.$linkUrl + '/open/api/getAccessToken?appKey=6d7b3ac7b22e4d58&secretKey=6d7b3ac7b22e4d58a96de98253',
           headers: {
              'User-Agent': 'Apifox/1.0.0 (https://apifox.com)'
           }
        };

        _that.$axios(config)
        .then(function (response) {
          _that.access_token = response.data.data.access_token
          let config2 = {
             method: 'post',
             url: _that.$linkUrl + '/open/api/getLinkQrImg?access_token=' + response.data.data.access_token + '&serviceId=' + _that.id,
             headers: {
                'User-Agent': 'Apifox/1.0.0 (https://apifox.com)'
             }
          };

          _that.$axios(config2)
          .then(function (response2) {
             _that.tableData = response2.data.data
          })
          .catch(function (error) {
             console.log(error);
          });
        })
        .catch(function (error) {
           console.log(error);
        });
      },
      //删除
      del(index){
          this.tableData.splice(index, 1)
      },
    //修改优先级
      editweight(index,weight){
          this.$prompt('请输入优先级', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            inputValue: weight
          }).then(({ value }) => {
            console.log(value)
            this.tableData[index].img_weight = value
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '取消输入'
            });
          });
      }
    },
    created() {
      window.myData = this
      this.id = this.$route.params.id
      this.type_id = this.$route.params.type_id
      this.gettoken()

    },
    mounted() {
    }
  }
</script>

<style src="@wangeditor/editor/dist/css/style.css"></style>



// WEBPACK FOOTER //
// src/views/weike/child.vue